    <div class="row">
        <div class="col form-field">
            <input name="search"
                   class="form-control"
                   #searchInput
                   [placeholder]="'bcContestProgram_search' | translate"
                   (input)="filter(searchInput.value)">
        </div>

        <div class="col text-end">
            <button type="button"
                    class="btn btn-outline"
                    (click)="submit()">
                <i class="fi fi-rs-shield-check"></i>
                {{'bcContest_btnSubmitAll' | translate}}
            </button>
        </div>
    </div>

<app-table [rows]="items" [columns]="columns" sticky="right">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Code}}</td>
            <td>{{row.Total}}</td>
            <td>{{row.Submitted}}</td>
            <td>{{row.Pending}}</td>
            <td>
                <div class="table-actions">
                    <button type="button"
                            class="btn btn-outline btn-icon"
                            [disabled]="!row.Pending"
                            [ngbTooltip]="'bcContest_btnSubmit' | translate"
                            (click)="submit(row)" >
                        <i class="fi fi-rs-shield-check"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
